import React, { useState, useEffect } from "react";
import "./style.css";
import { getSingleRiderShifts } from "../../../../services/riders.service";
import {Table, Typography, Card, Collapse} from "antd";
import Pageloader from "../../../../components/loader";
import moment from "moment";
import { validationErrors } from "../../../../utils/Helpers";

const { Text } = Typography;
const { Panel } = Collapse;
const pagename = "Shift";


const RiderDetailShift = (props) => {
  const [postData, setPostData] = useState(null);
  const [postDataPaginate, setPostDataPaginate] = useState(null);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (postData) {
  //     setErrMsg(null);
  //   }
  // }, [postData]);
  // useEffect(() => {
  //   postLists();
  // }, []);

  const postLists = async (pageNumber, pageSize) => {
    try {
      // console.log(pageNumber, pageSize)
      setLoading(true);
      const rID = props.RiderIDforShift;
      const resp = await getSingleRiderShifts(rID, pageNumber, pageSize);
      setPostData(resp.data.data);
      setPostDataPaginate(resp.data.pagination);
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const [search, setSearch] = useState("");
  const searchkeys = ["zone"];
  const globalSearch = (postData) => {
    if (search.length == 0) {
      return postData;
    } else {
      return postData.filter((item) =>
        searchkeys.some((key) => item[key].toLowerCase().includes(search))
      );
    }
  };
  
  const convertStartTime = (ST) => {
    const STview = moment.unix(ST).format("DD MMMM, yyyy, h:mm A");
    return STview;
  };

  let currentDateTimeStamp = moment().format("X");
  const postColumns = [
    {
      title: "Shift ID",
      dataIndex: "display_id",
    },
    {
      title: "Zone",
      render: (zone) => (zone != null ? <Text>{zone.zoneName}</Text> : ""),
      dataIndex: "zone",
    },
    {
      title: "Start Date Time",
      render: (proId) => (proId ? convertStartTime(proId.startTime) : ""),
    },
    {
      title: "End Date Time",
      render: (proId) => (proId ? convertStartTime(proId.endTime) : ""),
    },
    {
      title: "Slots",
      render: (proId) => (proId ? <Text>{proId.totalSlots}</Text> : ""),
      // dataIndex: "shiftId",
    },
    {
      title: "Slots Filled",
      render: (proId) => (proId ? <Text>{proId.totalSlotsFilled}</Text> : ""),
      // dataIndex: "shiftId",
    },
    {
      title: "Status",
      render: (proId) => {
        return (proId.isActive === false || proId.isActive === true) &&
          currentDateTimeStamp >= Number(proId.startTime) &&
          currentDateTimeStamp >= Number(proId.endTime) ? (
          <Text style={{ color: "lightgrey" }}>Expired</Text>
        ) : currentDateTimeStamp >= Number(proId.startTime) &&
          currentDateTimeStamp <= Number(proId.endTime) &&
          proId.isActive === true ? (
          <Text type="success">Started</Text>
        ) : proId.isActive === true ? (
          <Text type="warning">Active</Text>
        ) : (
          <Text type="danger">Inactive</Text>
        );
      },
      // dataIndex: "shiftId",
    },
  ];

  const pageChange = (pageNumber, pageSize) => {
    postLists(pageNumber, pageSize)
  };

  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?()=>postLists(1,10):()=>{}}>
        <Panel header={pagename}>
          {loading ? <Pageloader/>:
            <Table 
              dataSource={globalSearch(postData)} 
              columns={postColumns} 
              pagination={{
                current: postDataPaginate?.currentPage,
                pageSize: postDataPaginate?.limit,
                pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
                showSizeChanger: true,
                total: postDataPaginate?.totalCount, // total count returned from backend
                onChange: (page, pageSize) => {
                  pageChange(page, pageSize);
                },
              }}
              onRow={(r, i) => ({
                onDoubleClick: (e) => window.open(`/shifts/shiftView/${r.id}`),
              })}
            />
          }
        </Panel>
      </Collapse>
    </Card>

  );
};

export default RiderDetailShift;
